define('drops/action/action',[
	'jquery',
	'underscore',
    'when',
    'lq/drop',
    'lq/responsive',
    'lq/asyncSubcriptions',
    'lq/services/action/actionServiceFactory',
    'lq/style',
    'lq/stylesheets',
    'lq/pageLoadEventManager',
    'lq/cookie'
], function (
    $,
	_,
    when,
    Drop,
    responsive,
    asyncSubcriptions,
    actionServiceFactory,
    Style,
    stylesheets,
    PageLoadEventManager,
    cookie
) {
    'use strict';

    var defaults ={
        data: {
            type: 'Action',
            masterPageId: null,
            contentRegionActionId: null,
            embeddable: false,
            appliedLayouts: []
        }
    };

    var keyDownHandler = function (e) {
        // might need some tweaking
        if (e.which === 8 && !$(e.target).is("input, textarea, div[contenteditable=true]"))
            e.preventDefault();
    };

    var instanceCounter = 0;

    function Action(model, options) {
        Drop.call(this, $('<div class="licquid-drops-pool" style="overflow:hidden;"></div>'), defaults, model);

        this.instanceId = Action.nextInstanceId();

        // todo add a real fix for this
        // backwards compatibility -> &nbsp; is needed for the positioning of RadioButtonGroup, but
        // we can't add it when the action is positioned relative
        if (!(this.data.makeItGrow && this.data.growingDrop))
            this.$element.html('&nbsp;');

        this.options = options;

        this.rootDrop = this;

    	if (this.data.useScroll)
    	    this.$element.css('overflow', 'visible');

        this.$masterPage = $('<div class="licquid-drops-pool-master-page" />');
        this.$pageAnchored = $('<div class="licquid-drops-pool-page-anchored" />');

        if (this.options.disableBackspaceNavigation)
            this.subscribeEventHandler($(document), 'keydown', keyDownHandler);

        this.addSwipeEvents();
    };

    Drop.extend(Action, Drop);

    Action.nextInstanceId = function() {
        return instanceCounter++;
    };

    // Variables to track starting and current touch positions
    var xStart = null;
    var yStart = null;
    var xCurrent = null;
    var yCurrent = null;

    // Add swipe events to action -  swipe left, swipe right, pull down

    Action.prototype.addSwipeEvents = function () {
        if (this.isEventEnabled('swipeLeft') || this.isEventEnabled('swipeRight')) {
            this.subscribeEventHandler($(document), 'touchstart', this.handleTouchStart.bind(this));
            this.subscribeEventHandler($(document), 'touchmove', this.handleTouchMove.bind(this));
        }
    };

    // Get touches
    Action.prototype.getTouches = function (evt) {
        return evt.touches ||             // browser API
            evt.originalEvent.touches; // jQuery
    };

    // Get the touch's starting position
    Action.prototype.handleTouchStart = function (evt) {
        var touchStart = this.getTouches(evt)[0];

        xStart = touchStart.clientX;
        yStart = touchStart.clientY;
    };

    Action.prototype.handleTouchMove = function (evt) {
        if (!xStart || !yStart || !this.piping) {
            return;
        }

        var touchCurrent = this.getTouches(evt)[0];

        xCurrent = touchCurrent.clientX;
        yCurrent = touchCurrent.clientY;

        var xDiff = xStart - xCurrent;
        var yDiff = yStart - yCurrent;

        var thresholdOfLeftSwipeBack = 20;

        if (Math.abs(xDiff) > Math.abs(yDiff) && xStart > thresholdOfLeftSwipeBack) {/*most significant*/
            if (xDiff > 0) {
                /* left swipe */
                this.triggerEventIfEnabled('swipeLeft');
            } else {
                /* right swipe */
                this.triggerEventIfEnabled('swipeRight');
            }
        }
    };

    Action.prototype.scrollEventHandler = function () {
        if (this.data.verScrollGt) {
            if (!this.verScrollLimitGt) {
                if (this.data.verScrollGt < this.piping.$actionWrapper[0].scrollTop) {
                    this.triggerEventIfEnabled('verticalScrollGreaterThan');
                    this.verScrollLimitGt = true;
                }
            } else if (this.data.verScrollGt >= this.piping.$actionWrapper[0].scrollTop) {
                this.verScrollLimitGt = false;
            }
        }
        if (this.data.horScrollGt) {
            if (!this.horScrollLimitGt) {
                if (this.data.horScrollGt < this.piping.$actionWrapper[0].scrollLeft) {
                    this.triggerEventIfEnabled('horizontalScrollGreaterThan');
                    this.horScrollLimitGt = true;
                }
            } else if (this.data.horScrollGt >= this.piping.$actionWrapper[0].scrollLeft) {
                this.horScrollLimitGt = false;
            }
        }

        if (this.data.verScrollLt) {
            if (!this.verScrollLimitLt) {
                if (this.data.verScrollLt > this.piping.$actionWrapper[0].scrollTop) {
                    this.triggerEventIfEnabled('verticalScrollSmallerThan');
                    this.verScrollLimitLt = true;
                }
            } else if (this.data.verScrollLt <= this.piping.$actionWrapper[0].scrollTop) {
                this.verScrollLimitLt = false;
            }
        }
        if (this.data.horScrollLt) {
            if (!this.horScrollLimitLt) {
                if (this.data.horScrollLt > this.piping.$actionWrapper[0].scrollLeft) {
                    this.triggerEventIfEnabled('horizontalScrollSmallerThan');
                    this.horScrollLimitLt = true;
                }
            } else if (this.data.horScrollLt <= this.piping.$actionWrapper[0].scrollLeft) {
                this.horScrollLimitLt = false;
            }
        }
    };

    Action.prototype.unsubscribeEventHandlers = function () {
        if (this.$mockViews) this.$mockViews.remove();
        stylesheets.unloadFor(this.data.id);
        PageLoadEventManager.abortEvents(this.instanceId);

        _.forEach(this.services, function (service) {
            service.dispose();
        });

        asyncSubcriptions.unsubscribeActionInstance(this.instanceId);

        // the view is reused by the next action, the sized background layers must not stay behind
        this.$masterPage.remove();
        this.$pageAnchored.remove();
    };

    Action.prototype.applyLayout = function (currentLayout, useMinimumSizes) {
        if (currentLayout) {
            this.piping.parameters.systems.setValue('CurrentLayoutName', currentLayout.name);
            responsive.applyLayoutRecursive(this, currentLayout);
        }

        this.useMinimumSizes = useMinimumSizes;

        this.layout = currentLayout;
        this.updateBackgroundSize(this.data);
    };

    Action.prototype.runningOnHandheldDevice = function () {
        if(!this.layout)
            return false;
        return this.layout.deviceTypeName === 'Phone' || this.layout.deviceTypeName === 'Tablet';
    };

    Action.prototype.shouldUseWidthOfLayout = function () {
        return this.runningOnHandheldDevice() && $.isNumeric(this.data.left) && $.isNumeric(this.data.right);
    };

    Action.prototype.preRender = function () {
        this.applyPosition();

        if (this.canGrow()) {
            this.piping.$actionView.addClass('relative-positioning');

            // if the width of the screen is smaller than the total width required by the action
            // we have to explicitely set the width off the body, otherwise the background layer won't
            // grow beyond the right edge of the window
            if (!$.isNumeric(this.data.left) || !$.isNumeric(this.data.right)) {
                var minWidth = this.data.size.x;

                if ($.isNumeric(this.data.left))
                    minWidth += this.data.left;

                if ($.isNumeric(this.data.right))
                    minWidth += this.data.right;

                this.piping.$actionView.css({
                    minWidth: minWidth + 'px'
                });
            }
        } else {
            this.piping.$actionView.addClass('absolute-positioning');
        }

        _.forEach(this.services, function (applicationService) {
            applicationService.initialize();
        });

        if (window.self !== window.top) {
            document.documentElement.classList.add('nested-iframe');
        }

        Style.renderStyles(this, null, this.piping.$actionWrapper);
    };

    Action.prototype.doesThisMakeMeGrow = function (otherDrop) {
        return this.canGrow() && this.data.growingDrop === otherDrop.data.name;
    };

    Action.prototype.canGrow = function () {
        return !!(this.data.makeItGrow && this.data.growingDrop);
    };

    Action.prototype.createAndRenderDrops = function ($viewport) {
        this.piping.$actionView
            .removeClass('relative-positioning absolute-positioning')
            .removeAttr('style');

        this.resizeViewport($viewport);

        this.$masterPage.appendTo(this.piping.$actionView);
        this.$pageAnchored.appendTo(this.piping.$actionView);

        $.each(this.backgroundDrops, function (index, model) {
            model.renderInBackground = true;
        });

        var morphs = this.childDrops.concat(this.backgroundDrops);
        this.addRootMorph(morphs);

        var drops = this.piping.dropFactory.createDrops(morphs);

        var self = this;
        _.each(drops, function (drop) {
            self.addDrop(drop);
        });

        self.piping.eventing.bindEvents();

        return self.render(this.piping.$actionView);
    };

    Action.prototype.startEventing = function() {
        var deferred = when.defer();

        // WHY: the page may be gone before its eventing starts (a newer page replaced it while it waited for its turn),
        // its page load event must not run anymore; like an aborted page load event the promise never resolves
        if (!this.isActive()) return deferred.promise;

        PageLoadEventManager.scheduleEvent(
            this.instanceId,
            this.piping.eventing.triggerPageLoadEvent.bind(this.piping.eventing),
            this.afterPageLoadEvent.bind(this, deferred)
        );

        return deferred.promise;
    };

    Action.prototype.afterPageLoadEvent = function(deferred, aborted) {
        var savedView = cookie.get(this.getViewCookieKey());
        if (savedView) {
            this.applyView(savedView);
        } else if (this.pendingViewKey) {
            cookie.set(this.getViewCookieKey(), this.pendingViewKey, 1);
        }

        if (aborted) return;

        deferred.resolve();
    };

    Action.prototype.postRender = function () {
        if (this.selectedView) this.applyViewToDrops(this.selectedView);

    	// click fall-through for master page drops
    	new PointerEventsPolyfill({
            selector: '.licquid-drops-pool'
        });

        if (this.data.scrollEventEnabled) {
            this.verScrollLimitGt = false;
            this.horScrollLimitGt = false;
            this.verScrollLimitLt = false;
            this.horScrollLimitLt = false;

            this.subscribeEventHandler(this.piping.$actionWrapper,
                'scroll', this.scrollEventHandler.bind(this));
        }
    };

    Action.prototype.updateBackgroundSize = function (data) {
        var positioning = {};

        data = data || this.data;

        if (this.canGrow()) {
            positioning.height = '100%';
            positioning.width = '100%';
        } else {
            if (data.top != null && data.bottom != null) {
                // action is anchored at both sides, so the background needs to cover the entire window
                positioning.top = 0;
                positioning.bottom = 0;
            } else if (data.bottom && data.bottom < 0) {
                positioning.bottom = data.bottom;
            } else if (this.useMinimumSizes) {
                if (this.options.windowMinHeight != null && this.options.windowMinHeight > data.size.y)
                    positioning.minHeight = this.options.windowMinHeight;
                else
                    positioning.minHeight = data.size.y;

                if (data.top)
                    positioning.minHeight += data.top;
                else
                    positioning.minHeight += data.position.y;
            }

            if (data.right != null && data.left != null) {
                // action is anchored at both sides, so the background needs to cover the entire window
                positioning.right = 0;
                positioning.left = 0;
            } else if (data.right && data.right < 0) {
                positioning.right = data.right;
            } else {
                positioning.minWidth = data.size.x;
            }
        }

        this.$masterPage.css(positioning);
        this.$pageAnchored.css(positioning);
    };

    Action.prototype.resizeViewport = function ($viewport) {
        if ($viewport.length === 0)
            return;

        if (this.runningOnHandheldDevice()) {
            $viewport.attr('content', 'width=' + this.data.size.x + ', user-scalable=yes');
        } else {
            var scale = 1;
            var ww = $(window).width();
            var width = 'device-width';
            var wscale = 1;
            var hscale = 1;

            if (this.options.viewportScaleForWidth && (this.data.left !== null || this.data.right !== null || this.data.centered === true)) {
                var actionWidth =
                   (this.data.centered === true
                       ? this.data.size.x
                       : (this.data.left || this.data.position.x) + this.data.size.x + (this.data.right || 0));

                if (!this.options.viewportScaleForHeight) {
                    var width = this.layout && this.data.size.x > this.layout.windowMinWidth ? this.layout.windowMinWidth : this.data.size.x;
                    $viewport.attr('content', 'width=' + width + ', user-scalable=yes');
                    return;
                } else {
                    if (ww < actionWidth) wscale = ww / actionWidth;
                }
            }

            if (this.options.viewportScaleForHeight && (this.data.top !== null || this.data.bottom !== null)) {
                var wh = $(window).height();
                var actionHeight = this.data.size.y + (this.data.top || 0) + (this.data.bottom || 0);
                if (wh < actionHeight) hscale = wh / actionHeight;

                //if the device is too small, don't take the height into account for scaling
                if (ww < 768 || wh <= 390) hscale = 1;
            }

            scale = Math.min(wscale, hscale);

            $viewport.attr('content', 'width=device-width, initial-scale=' + scale + ', user-scalable=no');

            if (this.useMinimumSizes) {
                if (this.layout && this.layout.windowMinWidth !== null && this.layout.windowMinWidth !== undefined)
                    this.piping.$actionView.css('min-width', this.layout.windowMinWidth);
                else if (this.options.windowMinWidth)
                    this.piping.$actionView.css('min-width', this.options.windowMinWidth);

                if (this.layout && this.layout.windowMinHeight !== null && this.layout.windowMinHeight !== undefined && !this.canGrow())
                    this.piping.$actionView.css('min-height', this.layout.windowMinHeight);
                else if (this.options.windowMinHeight && !this.canGrow())
                    this.piping.$actionView.css('min-height', this.options.windowMinHeight);
            }
        }
    };

    Action.prototype.setContent = function (contentArray, locals, insertionPoint) {
        if(contentArray.length === 0) 
            return when.resolve();

        // the page may have been replaced while its content was waiting for its turn
        if (!this.isActive())
            return when.resolve();
        
        var contentRegion = _.findWhere(this.piping.dropFactory.getAllDrops(), { type: 'ContentRegion' });
        if(!contentRegion) throw Error('No content region found');
        
        return contentRegion.setContent(contentArray, locals, insertionPoint);
    };

    Action.prototype.loadData = function (actionData) {
        this.backgroundDrops = actionData.backgroundDrops;
        this.allLayouts = actionData.allLayouts;
        this.defaultLayout = actionData.defaultLayout;
        this.actionType = actionData.actionType;
        this.isMockAction = !!actionData.isMockAction;
        this.isModalAction = !!actionData.isModalAction;
        this.isInitiallyRequested = !!actionData.isInitiallyRequested;

        this.prepareMockViews();

        var self = this;
        this.services = _.map(actionData.services, function (service) {
            return actionServiceFactory.createService(service, self);
        });
    };

    Action.prototype.isActive = function () {
        return !!this.piping;
    };

    Action.prototype.addRootMorph = function (morphs) {
        var self = this;
        _.each(morphs, function (morph) {
            morph.rootDrop = self;
            if ((!morph.data || morph.data.type !== "List") && $.isArray(morph.childDrops) && morph.childDrops.length > 0)
                self.addRootMorph(morph.childDrops)
        });
    };

    Action.prototype.activatePointAndClick = function () {
        this.pointAndClickActive = true;
        this.$element.addClass("point-and-click");
    };

    Action.prototype.deactivatePointAndClick = function () {
        this.pointAndClickActive = false;
        this.$element.removeClass("point-and-click");
    };

    Action.prototype.getViewCookieKey = function () {
        var key = "actionView_" + this.data.id;
        if (this.piping) {
            var mockSessionId = this.piping.parameters.getValue('MockSessionId');
            var executionId = this.piping.parameters.getValue('ExecutionId');
            if (mockSessionId) key += "_" + mockSessionId;
            if (executionId) key += "_" + executionId;
        }
        return key;
    };

    Action.prototype.prepareMockViews = function () {
        var self = this;
        if (!this.isMockAction) return;

        if (!this.$mockViews) 
            this.$mockViews = $("<div>")
                .addClass("mock-views")
                .appendTo($("#licquid-application"));
        else this.$mockViews.empty();

        var views = this.data.views;

        if ($.isArray(views) && views.length > 0) {
            var savedViewKey = cookie.get(this.getViewCookieKey());
            this.selectedView = savedViewKey ? _.find(views, { key: savedViewKey }) || views[0] : views[0];
            _.each(views, function (view) {
                view.$element = $("<div>")
                    .addClass("mock-view")
                    .toggleClass("mock-view-selected", self.selectedView === view)
                    .attr("title", view.name)
                    .attr("data-title", view.name)
                    .on("click", function () {
                        self.applyView(view.key);
                    })
                    .appendTo(self.$mockViews);
            });

            var labelsVisible = sessionStorage.getItem("mockViewLabels");
            if (labelsVisible === "true") self.$mockViews.addClass("labels-visible");

            $("<div>")
                .addClass("mock-view")
                .addClass("mock-view-labels-toggle")
                .attr("data-title", "Show Labels")
                .toggleClass("mock-view-selected", labelsVisible === "true")
                .on("click", function () {
                    var isVisible = self.$mockViews.hasClass("labels-visible");
                    self.$mockViews.toggleClass("labels-visible", !isVisible);
                    sessionStorage.setItem("mockViewLabels", !isVisible);
                    $(this).toggleClass("mock-view-selected", !isVisible);
                })
                .prependTo(self.$mockViews);
        }
    };

    Action.prototype.applyView = function (viewKey) {
        var view;
        if (!viewKey) {
            viewKey = cookie.get(this.getViewCookieKey());
            if (!viewKey) {
                var views = this.data.views;
                if (views.length > 0) view = views[0];
                else return;
            }
        }
        if (!view) view = _.find(this.data.views, { key: viewKey });
        if (!view) return;

        cookie.set(this.getViewCookieKey(), view.key, 1);
        this.applyViewToDrops(view);
    };

    Action.prototype.applyViewToDrops = function (view) {
        this.pendingViewKey = view.key;
        if (this.selectedView && this.selectedView.$element) {
            this.selectedView.$element.removeClass("mock-view-selected");
        }
        if (view.$element) view.$element.addClass("mock-view-selected");
        this.selectedView = view;

        var views = this.data.views;
        _.each(this.pool, function (drop) {
            if (drop.data.type === "ModalPopup") return;
            if (drop.designData && drop.designData.isSystemDrop) return;
            if (drop.data.initialVisibility === false) return;

            var owningView = _.find(views, function (candidateView) {
                return candidateView && candidateView.drops && candidateView.drops.includes(drop.data.id);
            });

            if (!owningView || owningView.key === view.key) {
                drop.showWithoutAnimation();
            } else {
                drop.hideWithoutAnimation();
            }
        });
    };

    return Action;
});

